<template>
    <div class="col-md-12">
		<div class="row mb-3 mx-1">
		<h3><b>{{vendor.name}}</b> Preis Validierung</h3>
			<button
				type="button"
				class="btn btn-secondary btn-md mx-2 ml-auto"
				@click="() => {  window.location.href = '/vendorpricevalidator' }"
			>
				<span>zurück</span>
			</button>
		</div>
		<table class="table">
			<thead>
				<tr>
					<th scope="col">EAN</th>
					<th scope="col">Blockiert Seit</th>
					<th scope="col">Artikelzustand</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="itr in untrustedPrices" v-bind:key="itr.ean">
					<td>{{itr.ean}}</td>
					<td>{{itr.stamp}}</td>
					<td>{{itr.articleCondition}}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	export default {
		props: [ 'untrustedPrices', 'vendor' ]
	}
</script>
